export default __webpack_public_path__ + "static/media/Monitoring.8a0460f2.svg";